// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__f1pJN","dashboard":"Layout_dashboard__fDXW-","mainContent":"Layout_mainContent__8aS8t","noScroll":"Layout_noScroll__A2yMA","footer":"Layout_footer__jR2Ai"};